"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.availableSteps = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SummaryContainer = require("../container/SummaryContainer");

var _SummaryContainer2 = _interopRequireDefault(_SummaryContainer);

var _Success = require("./steps/Success");

var _Success2 = _interopRequireDefault(_Success);

var _GarageSelectorContainer = require("../container/steps/GarageSelectorContainer");

var _GarageSelectorContainer2 = _interopRequireDefault(_GarageSelectorContainer);

var _ServiceSelectorContainer = require("../container/steps/ServiceSelectorContainer");

var _ServiceSelectorContainer2 = _interopRequireDefault(_ServiceSelectorContainer);

var _TimeslotSelectorContainer = require("../container/steps/TimeslotSelectorContainer");

var _TimeslotSelectorContainer2 = _interopRequireDefault(_TimeslotSelectorContainer);

var _CustomerDataContainer = require("../container/steps/CustomerDataContainer");

var _CustomerDataContainer2 = _interopRequireDefault(_CustomerDataContainer);

var _VehicleSelectorContainer = require("../container/steps/VehicleSelectorContainer");

var _VehicleSelectorContainer2 = _interopRequireDefault(_VehicleSelectorContainer);

var _MobilityContainer = require("../container/steps/MobilityContainer");

var _MobilityContainer2 = _interopRequireDefault(_MobilityContainer);

var _scrollIntoView = require("scroll-into-view");

var _scrollIntoView2 = _interopRequireDefault(_scrollIntoView);

var _SimpleVehicleSelectorContainer = require("../container/steps/SimpleVehicleSelectorContainer");

var _SimpleVehicleSelectorContainer2 = _interopRequireDefault(_SimpleVehicleSelectorContainer);

var _reactSpinkit = require("react-spinkit");

var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var availableSteps = exports.availableSteps = ["garage", "service", "mobility", "timeslot", "vehicle", "simple-vehicle", "customer"];

var Reservation = function (_React$Component) {
  _inherits(Reservation, _React$Component);

  function Reservation(props) {
    _classCallCheck(this, Reservation);

    var _this = _possibleConstructorReturn(this, (Reservation.__proto__ || Object.getPrototypeOf(Reservation)).call(this, props));

    _this.state = {
      initialized: false
    };
    return _this;
  }

  _createClass(Reservation, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      this.props.initialize().then(function () {
        _this2.setState({
          initialized: true
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (document.querySelector(".disable-autoscroll")) return;
      (0, _scrollIntoView2.default)(this.el);
    }
  }, {
    key: "renderFormStep",
    value: function renderFormStep(currentStep) {
      switch (currentStep) {
        case "garage":
          return _react2.default.createElement(_GarageSelectorContainer2.default, null);

        case "service":
          return _react2.default.createElement(_ServiceSelectorContainer2.default, null);

        case "mobility":
          return _react2.default.createElement(_MobilityContainer2.default, null);

        case "timeslot":
          return _react2.default.createElement(_TimeslotSelectorContainer2.default, null);

        case "vehicle":
          return _react2.default.createElement(_VehicleSelectorContainer2.default, null);

        case "simple-vehicle":
          return _react2.default.createElement(_SimpleVehicleSelectorContainer2.default, null);

        case "customer":
          return _react2.default.createElement(_CustomerDataContainer2.default, null);
      }
    }
  }, {
    key: "renderFoo",
    value: function renderFoo() {
      var formStep = this.renderFormStep(this.props.currentStep);

      if (this.props.hasSubmitted) {
        return _react2.default.createElement(_Success2.default, {
          onBookingSuccess: this.props.onBookingSuccess
        });
      }

      return formStep;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (!this.state.initialized) return _react2.default.createElement(_reactSpinkit2.default, {
        name: "line-scale",
        fadeIn: "quarter"
      });
      return _react2.default.createElement("div", {
        ref: function ref(el) {
          return _this3.el = el;
        },
        id: "otr",
        className: "appointment"
      }, _react2.default.createElement("div", {
        className: "head"
      }, "Online-Terminreservierung"), this.renderSummary(), _react2.default.createElement("div", {
        className: "main"
      }, _react2.default.createElement("div", {
        className: "probar"
      }, _react2.default.createElement("div", {
        id: "progress",
        style: {
          width: this.props.progress === 0 ? 10 : this.props.progress + "%"
        }
      })), this.renderFoo()));
    }
  }, {
    key: "renderSummary",
    value: function renderSummary() {
      if (this.props.currentStep) {
        return _react2.default.createElement(_SummaryContainer2.default, null);
      }
    }
  }]);

  return Reservation;
}(_react2.default.Component);

Reservation.propTypes = {
  currentStep: _propTypes2.default.string,
  progress: _propTypes2.default.number.isRequired,
  initialize: _propTypes2.default.func.isRequired,
  hasSubmitted: _propTypes2.default.bool.isRequired,
  isSubmitting: _propTypes2.default.bool.isRequired,
  onBookingSuccess: _propTypes2.default.func
};
exports.default = Reservation;